// this will not be used as a type in the Analytics services until ticket 16651 as it requires a retrofit
enum AnalyticsEventName {
    TabInteraction = "tab_interaction",
    EnquiryFormSubmitError = "enquiry_form_submit_error",
    EnquiryFormValidationError = "enquiry_form_validation_error",
    AccordionInteraction = "accordion_interaction",
    CardsFilterInteraction = "filter_interactions",
    CardsFilterInteractionClear = "filter_interactions_clear",
    LiveChatInteraction = "livechat_interaction",
    Pagination = "pagination",
    PageSize = "page_size",
    EnquiryFormSubmission = "dropdown_interactions",
    EnquirySuccess = "enquiry_success",
    LeftHandNavEvent = "lhnav_link_click",
    NewsletterSubmitError = "newsletter_submit_error",
    NewsletterSuccess = "newsletter_success",
    NewsletterFormValidationError = "newsletter_form_validation_error",
}

export { AnalyticsEventName };